<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kyTtqt/tc-custom/9781644031988.jpg?1734032676984" alt="This image is the cover for the book Photo Memory Quilts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Photo Memory Quilts
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Transform treasured photographs into quilts to be displayed and passed down as heirlooms—from the internationally known mixed media artist and quilter.</b></p><p>Lesley Riley guides makers on successfully transferring vintage photos onto fabric using Transfer Artist Paper, custom printing, and more methods. Use the photo fabric to create an art quilt that honors and preserves the sentimental value of your photographs. A fresh and contemporary approach, Lesley's quilt instruction focuses on using modern technology and storytelling techniques through photos, fabric choice, and embellishment. Follow along to design your photo memory quilt, from selecting your subject and sourcing photos, to digitally manipulating vintage photos and transferring the images to fabric. </p>Create engaging memory quilts using art principles, design concepts, and modern technology, including how to repair, enhance, and manipulate your photos to achieve the perfect images for your projects. 8 projects allow readers to try their hands at this updated art form, and a gallery of pieces by quilt artists shows a variety of inspiring family stories. Tell the story of your choice through fabric selection, with guidance on using repurposed fabrics, vintage textiles, and more.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lesley Riley
      </h2>
      
      <p class="authorDescription body article">Lesley Riley is an internationally known mixed-media artist, quilter, teacher, writer, and artist success mentor who turned her initial passion for photos, color, and the written word into a dream "occupassion." In an ongoing effort to find the best ways for quilters and mixed media artists to get permanent photos on fabric, Lesley introduced Transfer Artist Paper™, named the Craft & Hobby Association (CHA) 2011 Most Innovative new product. Lesley creates her magic on an idyllic mountain top hideaway in Cascade, MD, where she lives with her high-school sweetheart husband. LesleyRiley.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Published by C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e7cf1c42